import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "files-box"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", { class: "title mt-4 mb-3" }, "Files", -1)
const _hoisted_3 = { class: "list-group list-group-numbered" }
const _hoisted_4 = { class: "ms-2 me-auto" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "px-1" }, "•", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "px-1" }, "•", -1)

import { computed } from 'vue';
import { useDriveStore } from '@/modules/drive/store/driveStore';
import { fileType, createdDate, mediaSize } from '@/helpers/utils';
import { useMainStore } from '@/store/mainStore';
import NativeService from '@/services/NativeService';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const driveStore = useDriveStore();
const mainStore = useMainStore();

function openFile(file) {
  const isPDF = computed(() => file.name?.includes('.pdf'));
  const fileUrl = computed(() => process.env.VUE_APP_MEDIA_URL + file.fileUrl);
  // callback for native app
  if (isPDF.value && mainStore.isMobile) {
    NativeService.getPdfUrl(fileUrl.value);
    return;
  }
  if (isPDF.value && !mainStore.isMobile) {
    window.open(fileUrl.value, '_blank');
    return;
  }
  driveStore.appPhotoViewMedia = file;
}

return (_ctx: any,_cache: any) => {
  return (_unref(driveStore).currentCase.files.length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("ol", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(driveStore).currentCase.files, (file) => {
            return (_openBlock(), _createElementBlock("li", {
              class: "list-group-item d-flex justify-content-between align-items-start",
              key: file.id
            }, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("h5", {
                  class: "title mb-1",
                  onClick: ($event: any) => (openFile(file))
                }, _toDisplayString(file.name), 9, _hoisted_5),
                _createElementVNode("div", null, [
                  _createElementVNode("span", null, _toDisplayString(_unref(fileType)(file.name)), 1),
                  _hoisted_6,
                  _createElementVNode("span", null, _toDisplayString(_unref(createdDate)(file.creationDate, 'MMM DD, YYYY')), 1),
                  _hoisted_7,
                  _createElementVNode("span", null, _toDisplayString(_unref(mediaSize)(file.size)), 1)
                ])
              ])
            ]))
          }), 128))
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})